/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\HrStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 15th 2023, 5:48:08 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const HrStyled = styled.hr.attrs((props: any) => ({
    bgColor: props.bgColor,
    margin: props.margin
}))`
margin: -0.2rem auto 0;
margin: ${(props: any) => props.margin};
width: 95%;
border-top: 3px solid ${(props: any) => getThemeColor(props.bgColor)};
`;

export default HrStyled;
